import Gem from "../logos/gem";
import Latitude from "../logos/latitude";
export var logoListMapping = {
  gem: Gem,
  latitude: Latitude
};